import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '..';
import { IResult } from '../../shared/iResult';
import { EReduxState } from '../enum';
import { IReduxState } from '../interface';

const initialState: IReduxState<IResult> = {
    status: EReduxState.initialState,
};

export const resultSlice = createSlice({
    name: 'result',
    initialState,
    reducers: {
        cleanResult: state => {
            state.status = EReduxState.initialState;
            state.data = undefined;
        },
        setResult: (state, action: PayloadAction<IResult>) => {
            state.status = EReduxState.fulfilled;
            state.data = action.payload;
        },
    },
});

export const { cleanResult, setResult } = resultSlice.actions;

export const selectResult = (state: RootState) => state.result;

export default resultSlice.reducer;
